<template>
    <v-dialog v-model="show" max-width="600" persistent no-click-animation>
        <div class="block-relative">
            <loading-inside-component v-if="dataLoading"></loading-inside-component>
            <v-form v-model="formValid" ref="form" @submit="submit">
                <v-card>
                    <v-card-title primary-title class="headline grey lighten-2 pa-0">
                        <v-layout row justify-space-between align-center>
                            <div class="ml-3">Request Consent Zalo</div>
                            <v-btn flat icon @click="close">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <p v-if="customer">
                            <b>
                                {{ $t('customer') | capitalize }}:
                                {{ customer.name }}
                            </b>
                        </p>
                        <v-select
                            v-model="config.reason_code"
                            :items="reason_codes"
                            item-text="value"
                            :label="$t('reason_code') | capitalize"
                            :rules="formRules.required"
                            return-object
                        ></v-select>
                        <v-select
                            v-model="config.customers[0].phone_number"
                            :items="phoneList"
                            :label="$t('phone') | capitalize"
                            :rules="formRules.required"
                        ></v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="gray" depressed small @click="close">
                            Cancel
                        </v-btn>
                        <v-btn color="primary" depressed small type="submit">
                            Send
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </div>
    </v-dialog>
</template>
<script>
import LoadingInsideComponent from '@/components/LoadingInsideComponent'
import CampaignService from '@/services/campaign.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import {mapState} from 'vuex'

export default {
    name: 'RequestConsentZaloDialog',
    mixins: [
        FormMixin
    ],
    components: {
        LoadingInsideComponent
    },
    data() {
        return {
            show: false,
            dataLoading: false,
            formValid: false,
            customer: false,
            selected: {},
            voices: [],
            phoneList: [],
            voice_speed: 1,
            reason_codes: [
                {
                    code: "101",
                    value: "Xác nhận thông tin khách hàng"
                },
                {
                    code: "102",
                    value: "Xử lý khiếu nại"
                },
                {
                    code: "103",
                    value: "Thẩm định hồ sơ"
                }
            ],
            call_types: ['audio', 'video', 'audio_and_video'],
            config: {
                campaign_id: this.$route.params['campaignId'],
                call_type: 'audio',
                reason_code: '',
                customers: [{}]
            }
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    methods: {
        open(customer) {
            this.show = true
            this.resetModel()
            if (customer) {
                this.customer = customer
            }
            this.config.customers[0].customer_id = customer.id
            this.dataLoading = true
            let min_priority = 10000
            this.phoneList = customer.phone_numbers.map(phone => {
                if (phone.priority < min_priority) {
                    min_priority = phone.priority
                    this.config.customers[0].phone_number = phone.phone_number
                }
                return {
                    text: phone.phone_number,
                    value: phone.phone_number
                }
            })
            this.$nextTick().then(() => {
                this.dataLoading = false
                this.$refs.form.resetValidation()
            })
            // CampaignService.getVoices().then(res => {
            //     if (res.data.length) {
            //         this.voices = res.data
            //         this.voices.forEach(item => {
            //             if (item.default) {
            //                 this.selected.voice = item.voice
            //             }
            //         })
            //     }
            //     this.$nextTick().then(() => {
            //         this.dataLoading = false
            //         this.$refs.form.resetValidation()
            //     })
            // })
        },
        close() {
            this.resetModel()
            this.show = false
        },
        submit(event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                this.dataLoading = true
                const i18n = {
                    action: this.$t('send'),
                    item: this.$t('request')
                }
                CampaignService.requestConsentZalo(this.config).then(res => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                    this.dataLoading = false
                    this.$emit('success')
                    this.close()
                }, err => {
                    this.dataLoading = false
                    this.$appService.handleRequestError(this.$t('actionFailed', i18n))
                })
            } else {
                this.$refs.form.validate()
            }
        },
        resetModel() {
            this.customer = false
            this.selected = {}
            this.voices = []
        }
    },
    beforeDestroy() {
        this.resetModel()
    }
}
</script>
<style scoped>
::v-deep .v-slider__thumb-label {
    border-radius: 50% 50% 0;
    transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);

}
</style>
